import { v4 as uuidv4 } from 'uuid';

const hardwareData = () => {

    return [
        {
            id: uuidv4(),
            image: "https://images-na.ssl-images-amazon.com/images/I/61cuElU6PaL._SX679_.jpg",
            name: "Microsoft Surface Laptop Go",
            price: 69990,
        },
        {
            id: uuidv4(),
            image: "https://m.media-amazon.com/images/I/71vYmDQElqL._AC_SS450_.jpg",
            name: "RUNMUS K11 Over-Ear 7.1",
            price: 15495,
        },
        {
            id: uuidv4(),
            image: "https://images-na.ssl-images-amazon.com/images/I/71Td-My5f-L._SL1500_.jpg",
            name: "HP Smart Tank 530 Dual Band",
            price: 16495,
        },
        {
            id: uuidv4(),
            image: "https://images-na.ssl-images-amazon.com/images/I/81PBkciE0ML._SL1500_.jpg",
            name: "Dragonwar ELE-G9 Thor Wired BlueTrack",
            price: 15495,
        },
        {
            id: uuidv4(),
            image: "https://images-na.ssl-images-amazon.com/images/I/61cuElU6PaL._SX679_.jpg",
            name: "Microsoft Surface Laptop Go",
            price: 69990,
        },
        {
            id: uuidv4(),
            image: "https://m.media-amazon.com/images/I/71vYmDQElqL._AC_SS450_.jpg",
            name: "RUNMUS K11 Over-Ear 7.1",
            price: 15495,
        },
        {
            id: uuidv4(),
            image: "https://images-na.ssl-images-amazon.com/images/I/61cuElU6PaL._SX679_.jpg",
            name: "Microsoft Surface Laptop Go",
            price: 69990,
        },
        {
            id: uuidv4(),
            image: "https://m.media-amazon.com/images/I/71vYmDQElqL._AC_SS450_.jpg",
            name: "RUNMUS K11 Over-Ear 7.1",
            price: 15495,
        },

    ]
}

export default hardwareData;